import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { SkillProfile } from "@app/models/rest/skill-profile";

@Injectable({
  providedIn: "root"
})
export class SkillProfileRestService extends HateoasResourceOperation<SkillProfile> {
  constructor() {
    super(SkillProfile);
  }
}
